import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ontos_remove_button = _resolveComponent("ontos-remove-button")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    label: _ctx.hideLabel ? '' : _ctx.label,
    items: _ctx.options,
    "item-title": "name",
    "item-value": "id",
    readonly: _ctx.readonly,
    loading: _ctx.loading,
    disabled: _ctx.disabled,
    "menu-icon": _ctx.menuIcon,
    multiple: _ctx.multiple,
    "error-messages": _ctx.errorMessage,
    hint: _ctx.hint,
    "persistent-hint": !!_ctx.hint,
    variant: _ctx.outlined ? 'outlined' : undefined,
    density: _ctx.dense ? 'compact' : undefined,
    "model-value": _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('input', $event))),
    onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur')))
  }, {
    item: _withCtx(({item, props}) => [
      (_ctx.form === 'chip')
        ? (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({ key: 0 }, {...props, title: undefined}, {
            density: _ctx.dense ? 'compact' : undefined,
            ripple: ""
          }), {
            default: _withCtx(() => [
              _createVNode(_component_ontos_colored_value, {
                option: item,
                form: _ctx.form
              }, null, 8, ["option", "form"])
            ]),
            _: 2
          }, 1040, ["density"]))
        : (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({ key: 1 }, props, {
            density: _ctx.dense ? 'compact' : undefined,
            ripple: ""
          }), {
            prepend: _withCtx(() => [
              _createVNode(_component_v_icon, {
                size: "small",
                color: item.color
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.VALUE_DOT), 1)
                ]),
                _: 1
              }, 8, ["color"])
            ]),
            _: 2
          }, 1040, ["density"]))
    ]),
    selection: _withCtx(({item, index}) => [
      item
        ? (_openBlock(), _createElementBlock("span", {
            key: index,
            class: "choice-selection"
          }, [
            _createVNode(_component_ontos_colored_value, {
              option: item,
              form: _ctx.form
            }, null, 8, ["option", "form"]),
            (_ctx.canRemove)
              ? (_openBlock(), _createBlock(_component_ontos_remove_button, {
                  key: 0,
                  onClick: _withModifiers(($event: any) => (_ctx.remove(item)), ["stop","prevent"])
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["label", "items", "readonly", "loading", "disabled", "menu-icon", "multiple", "error-messages", "hint", "persistent-hint", "variant", "density", "model-value"]))
}